import { EMPTY_FLOORPLAN } from '@domain/floorplan';

import type { FloorplanContextValue } from './floorplan.type';

/** What a consumer sees when no provider is mounted (tests, storybook). */
export const FLOORPLAN_CONTEXT_DEFAULT: FloorplanContextValue = {
  floorplanState: EMPTY_FLOORPLAN,
  updateFloorPlanState: () => {},
  setFloorplanState: () => {},
  resetFloorplanState: () => {},
};
